

































































































import { Component, Vue} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../../../lib/ajax'
import AbpBase from '../../../../../../lib/abpbase'
@Component({
    name:'fundsExcel',
})
export default class FundsExcel extends AbpBase {
    initData:any = {
        searchData:{
            year: 2019,
            MaxResultCount:10
        },
        formData:{},
        tableData: [],
        pageSizeOpts:[10,20,30,40,100],
        searchInfo:{
            year: 2019,
        },
        tableColumn:[
            {
                title: '序号',
                key: 'index',
                align: 'center',
                width: 60,
                render: (h: any,params: any) => {
                    return h('span',params.index == (this.initData.tableData.items.length - 1)?'合计':params.index+1 )
                }
            },
            {
                title: '合同编号',
                key: 'contractCode',
                align: 'center',
                width: 100,
                render: (h: any,params: any) => {
                    return h('span',params.index == (this.initData.tableData.items.length - 1)?'共'+this.initData.tableData.totalCount+'行':params.row.contractCode )
                }
            },
            {
                title: '结算类型',
                key: 'settleTypeDesc',
                align: 'center',
                width: 200,
            },
            {
                title: '项目类别',
                key: 'projectTypeDesc',
                align: 'center',
                width: 200,
            },
            {
                title: '签订单位',
                key: 'signUnitName',
                align: 'center',
                width: 200,
            },
            {
                title: '业主单位',
                key: 'ownerUnit',
                align: 'center',
                width: 200,
            },
            {
                title: '项目名称',
                key: 'projectName',
                align: 'center',
                width: 200,
            },
            {
                title: '收款责任人',
                key: 'tickGatherLeader',
                align: 'center',
                width: 200,
            },
            {
                title: '项目技术负责人',
                key: 'techLeaderName',
                align: 'center',
                width: 200,
            },
            {
                title: '生产科室',
                key: 'secondBearerOrgName',
                align: 'center',
                width: 200,
            },
            {
                title: '总额统计',
                align: 'center',
                children:[
                    {
                        title: '合同金额（元）',
                        key: 'projectAmountFormat',
                        align: 'center',
                        width: 200,
                    },
                    {
                        title: '项目收款总额（元）',
                        key: 'totalReceiptsFormat',
                        align: 'center',
                        width: 200,
                    },
                    {
                        title: '已开票（元）',
                        key: 'ticketAmountFormat',
                        align: 'center',
                        width: 200,
                    },
                    {
                        title: '未收款（元）',
                        key: 'unreceivableFormat',
                        align: 'center',
                        width: 200,
                    },
                    {
                        title: '预收收账款（元）',
                        key: 'advanceReceiptFormat',
                        align: 'center',
                        width: 200,
                    },
                    {
                        title: '应收账款（元）',
                        key: 'mustReceiptFormat',
                        align: 'center',
                        width: 200,
                    },
                ]
            },
            
            {
                title: '年度统计',
                align: 'center',
                children:[
                    {
                        title: '年度收款（元）',
                        key: 'yearReceiptAmountFormat',
                        align: 'center',
                        width: 200,
                    },
                    {
                        title: '税收成本（元）',
                        key: 'yearTaxAmountFormat',
                        align: 'center',
                        width: 200,
                    },
                    {
                        title: '管理成本（元）',
                        key: 'yearManagerAmountFormat',
                        align: 'center',
                        width: 200,
                    },
                    {
                        title: '生产支出（元）',
                        key: 'yearPayAmountFormat',
                        align: 'center',
                        width: 200,
                    },
                    // {
                    //     title: '所运行成本预留（元）',
                    //     key: '',
                    //     align: 'center',
                    //     width: 200,
                    // },
                    // {
                    //     title: '项目技术工作费预留（元）',
                    //     key: 'index',
                    //     align: 'center',
                    //     width: 200,
                    // },
                    {
                        title: '资金结余（元）',
                        key: 'yearBalanceFromat',
                        align: 'center',
                        width: 200,
                    }
                ]
            }
        ]
    }
    // 获取数据
    RunAmountStatistic() {
        Ajax.post('/api/services/app/NineFinanceManager/RunAmountStatisticAsync', this.initData.searchData)
            .then( (res: any) => {
                this.initData.formData = res.data.result;
            } )
    }
    InAndOutComeStatistic() {
        Ajax.post('/api/services/app/NineFinanceManager/InAndOutComeStatisticAsync', this.initData.searchInfo)
            .then( (res: any) => {
                console.log(res);
                this.initData.tableData = res.data.result;
                this.initData.tableData.items.push(res.data.result.sum)
            } )
    }
    //分页获取数据
    ChangePage(page:any) {
        this.initData.searchInfo.SkipCount = page-1;
        this.InAndOutComeStatistic()
    }
    //切换每页条数
    ChangePageNum(perPage:any){
        this.initData.searchInfo.MaxResultCount = perPage;
        this.InAndOutComeStatistic()
    }
    // 改变年份
    changeYear(value: any) {
        this.initData.searchData.year = value;
        this.RunAmountStatistic();
    }
    changeInfoYear(value: any) {
        this.initData.searchData.year = value;
        this.InAndOutComeStatistic();
    }
    mounted() {
        // 获取数据
        this.RunAmountStatistic()
        this.InAndOutComeStatistic();
    }
}
